
import React from 'react';
import { motion } from 'framer-motion';

interface ShirtIconProps {
  className?: string;
}

const ShirtIcon: React.FC<ShirtIconProps> = ({ className = "" }) => {
  return (
    <motion.div 
      className={`absolute -top-6 right-0 w-28 h-28 opacity-5 z-0 ${className}`}
      initial={{ scale: 0.8, opacity: 0 }}
      animate={{ scale: 1, opacity: 0.05 }}
      transition={{ duration: 0.5 }}
    >
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 4L19 4C19.5523 4 20 4.44772 20 5V7C20 7.55228 19.5523 8 19 8H18.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M8 4L5 4C4.44772 4 4 4.44772 4 5V7C4 7.55228 4.44772 8 5 8H5.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12 18L12 20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12 13L12 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <rect x="8" y="8" width="8" height="5" rx="1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M9 18.5C9 17.1193 10.1193 16 11.5 16H12.5C13.8807 16 15 17.1193 15 18.5V20H9V18.5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </motion.div>
  );
};

export default ShirtIcon;
